import { connect } from 'react-redux';
import { compose, setDisplayName, pure } from 'recompose';
import { createSelector } from 'reselect';

import { Error } from '../../views';
import { selectCodeError, selectMessageError } from '../../../selectors';

export default compose(
  setDisplayName('ErrorContainer'),
  connect(
    createSelector(
      selectCodeError(),
      selectMessageError(),
      (code, message) => ({ code, message })
    )
  ),
  pure
)(Error);
